import { useState } from 'react';
import { Tabs, Alert } from 'antd';
import FinoHome from './finoHome';
import DMTHistory from './../moneyTransfer/finohistory';
import RefundHistory from './refund';


const { TabPane } = Tabs;

const MyComponent = () => {
  const tabPosition = 'left';
  const [defaultKey, setDefaultKey] = useState('1');

  const onChangeHandler = (value) => {
    setDefaultKey(value);
  };

  return (
    <div>
      <div className="content-wrapper pt-2">
        <div className="content">
          <div className="container-fluid pt-2 pb-5">
            <div className="row">
              <div className="col-md-12">
                <div className="card rounded-0 p-3">
                  <Tabs
                    defaultActiveKey={defaultKey}
                    tabPosition={tabPosition}
                    onChange={onChangeHandler}
                  >
                    <TabPane tab="Home" key="1">
                      <div className="h-100">
                        {FinoHome ? <FinoHome /> : <Alert message="Error loading FinoHome" type="error" />}
                      </div>
                    </TabPane>

                    <TabPane tab={`History`} key="4">
                      <div className='h-100'>
                        <DMTHistory />
                      </div>
                    </TabPane>

                    <TabPane tab ={'Refund'} key="5">
                      <div className='h-100'>
                        <RefundHistory />
                      </div>
                    </TabPane>

                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyComponent;